import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./index.scss";
import { useTranslation } from "../../../hooks/useTranslation";
import { useState } from "react";

export default function CoworkingSection() {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);
  const items = [
    {
      imgClass: "img1",
      title: t("matoisCoworkingTitle"),
      text: [
        t("matoisCoworkingText1"),
        t("matoisCoworkingText2"),
        t("matoisCoworkingText3"),
      ],
    },
    {
      imgClass: "img2",
      title: t("msitConseilCoworkingTitle"),
      text: [
        t("msitConseilCoworkingText1"),
        t("msitConseilCoworkingText2"),
        t("msitConseilCoworkingText3"),
        t("msitConseilCoworkingText4"),
      ],
    },
    {
      imgClass: "img3",
      title: t("buzzTrackCoworkingTitle"),
      text: [
        t("buzzTrackCoworkingText1"),
        t("buzzTrackCoworkingText2"),
        t("buzzTrackCoworkingText3"),
        t("buzzTrackCoworkingText4"),
      ],
    },
    {
      imgClass: "img4",
      title: t("spotinCoworkingTitle"),
      text: [
        t("spotinCoworkingText1"),
        t("spotinCoworkingText2"),
        t("spotinCoworkingText3"),
      ],
    },
  ];
  const toggleOverlay = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <section className="coworking-section">
      <Container fluid className="p-0">
        <Row className="g-0">
          {items.map((item, index) => (
            <Col
              key={index}
              md={3}
              className={`image-card ${item.imgClass} d-flex align-items-center justify-content-center`}
            >
              <div
                className={`overlay ${
                  activeIndex === index ? "show-mobile" : ""
                }`}
              >
                {/* ✅ Bouton "Fermer" placé dans l’overlay */}
                {activeIndex === index && (
                  <Button
                    variant="light"
                    className="btn-close-overlay"
                    onClick={() => toggleOverlay(index)}
                  >
                    Fermer ✕
                  </Button>
                )}

                <h2>{item.title}</h2>
                <ul className="text-list">
                  {item.text.map((line, i) => (
                    <li key={i}>{line}</li>
                  ))}
                </ul>
              </div>

              {/* ✅ Bouton "Voir plus" visible uniquement si overlay fermé */}
              {activeIndex !== index && (
                <Button
                  variant="light"
                  className="btn-mobile"
                  onClick={() => toggleOverlay(index)}
                >
                  Voir plus
                </Button>
              )}
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
